"use strict";

const ProjectEnforcementController = require("./projectEnforcementController");
const BaseEnforcementAction = require("../../enforcement/baseEnforcementAction");

const EnforcementAction = function () {
  var getPropsFunction = function (data) {
    const openFindingsOptions = _getOpenFindingsOptions(data);
    return {
      levelOptions: FormSettings.getDropdownOptions("level", { tool: "indcom", sort: false }),
      enforcementReasonOptions: getEnforcementReasonOptions(data),
      openFindingsOptions,
      openFindings: data.openFindings,
    };
  };

  var getEnforcementReasonOptions = function (data) {
    const options = FormSettings.getDropdownOptions("enforcement-reason");

    return Object.keys(data?.openFindingsOptions ?? {})?.length === 0
      ? options.filter((option) => option.value !== "open-findings")
      : options;
  };

  var _getOpenFindingsOptions = function (data) {
    const observationCategoryOptions = ToolSettings.getDomainOptions("observation_category");
    const grouped = new Map();
    (data.openFindingsOptions ?? []).forEach((openFinding) => {
      const constant = NewProjectInspectionConstants.getConstantById(
        openFinding.observationConstantId,
      );
      if (constant) {
        const displayObservationCategory = Misc.getOptionNameByValue(
          observationCategoryOptions,
          constant.observationCategory,
        );

        if (!grouped.has(displayObservationCategory)) {
          grouped.set(displayObservationCategory, []);
        }
        const category = grouped.get(displayObservationCategory);
        category.push({
          name: getOpenFindingDisplay(openFinding),
          value: openFinding.id,
        });
      }
    });
    return grouped;
  };

  var getOpenFindingDisplay = function (openFinding) {
    const constant = NewProjectInspectionConstants.getConstantById(
      openFinding.observationConstantId,
    );
    return constant?.display + (openFinding.closed ? " (closed)" : "");
  };

  const base = BaseEnforcementAction(ProjectEnforcementController, { getPropsFunction });

  return {
    ...base,
    getEnforcementReasonOptions,
    getOpenFindingDisplay,
    _getOpenFindingsOptions,
  };
};

module.exports = EnforcementAction();

const FormSettings = require("../../settings/formSettings");
const Misc = require("../../misc");
const NewProjectInspectionConstants = require("../newInspections/newProjectInspectionConstants");
const ToolSettings = require("../../settings/toolSettings");
